import { useState } from 'react'

import type { PUSH_EVENT_LABEL } from '../../models/notification.constants'
import { getNotificationsAvailable } from '../../utils/getNotificationsAvailable'
import { offerPushNotifications } from '../components/PushRequest/offerPushNotifications'

const getPermission = () => (getNotificationsAvailable() ? Notification.permission : null)

export const usePermissionTrigger = (
  eventLabel: PUSH_EVENT_LABEL,
  onPermissionChanged: (permission: NotificationPermission | null, resetPermission: () => void) => void,
) => {
  const [permission, setPermission] = useState<NotificationPermission | null>(null)
  const resetPermission = () => {
    setPermission(null)
  }

  const onTrigger = async ({ isRetry }: { isRetry?: boolean } = {}) => {
    const currentPermission = getPermission()
    setPermission(currentPermission)
    if (!currentPermission || currentPermission === 'granted') {
      onPermissionChanged(currentPermission, resetPermission)
    } else if (currentPermission === 'default') {
      const newPermission = await offerPushNotifications({ eventLabel })
      setPermission(newPermission)
      if (newPermission !== 'denied' || isRetry) {
        onPermissionChanged(newPermission, resetPermission)
      }
    } else if (isRetry) {
      onPermissionChanged(currentPermission, resetPermission)
    }
  }

  return { onTrigger, permission, resetPermission }
}
